// extracted by mini-css-extract-plugin
export default {"cls1":"VeloModalSheetError-Container_cls1__c3QvE","cls2":"VeloModalSheetError-Container_cls2__mRk7b VeloModalSheetError-Container_cls1__c3QvE"};